import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BaseHeader from '../BaseHeader';

export interface Props {
  className?: string;
}

const ShopReportsHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <BaseHeader
      className={className}
      title={t('studio.header.reports.title')}
      subtitle={t('studio.header.reports.subtitle')}
    />
  );
};

ShopReportsHeader.displayName = 'ShopReportsHeader';

export default ShopReportsHeader;
